module.exports = "https://web-assets.ifttt.com/packs/media/location_field/location_enter_and_exit-39bb0e88.svg";